// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__dzyhX","options":"AnswerScale_options__36FLW","selected":"AnswerScale_selected__3WP-d"};